import axios from '@core_utils/api/_axios.js';

export default {
    namespaced: true,
    state: {
        contractor: {
            accesstoken: null,
            user_name: null,
            user_id: null,
            e_mail: null,
            company_name: null,
            company_id: null,
            is_authenticated: null,
            is_admin: null,
            type: null
        },
        project_list: [],
        request_time: null
    },
    getters: {
        Get_Contractor (state) {
            return state.contractor;
        },
        GET_ProjectList (state) {
            return state.project_list;
        },
        GET_CONTRACTOR_REQEUST_TIME (state) {
            return state.request_time;
        }
    },
    mutations: {
        SET_PROJECT_LIST (state, list) {
            state.project_list = list;
        },
        SET_CONTRACTOR_REQUEST_TIME (state, request_time) {
            // null 을 넘기면(로그아웃) 비우고, 인자 없이 부르면 지금 시각을 기록한다
            state.request_time = request_time === null ? null : new Date();
        },
        SET_CONTRACTOR_ACCOUNT (state, payload) {
            const _contract_account = {};
            for (const _info_key in payload) {
                _contract_account[_info_key.toLocaleLowerCase()] = payload[_info_key];
            }
            state.contractor = _contract_account;
        },
        SET_CONTRACTOR_INITIAL (state) {
            state.contractor = {
                accesstoken: null,
                user_name: null,
                user_id: null,
                e_mail: null,
                company_name: null,
                company_id: null,
                is_authenticated: null,
                is_admin: null,
                type: null
            };
        }
    },
    actions: {
        async LogoutContractor ({ state, commit }) {
            // 서버 세션 무효화가 실패해도(네트워크·5xx) 로컬 세션은 반드시 정리한다 — 공용 PC 에 로그인이 남지 않게.
            // 실패는 호출부로 전달된다(호출부는 실패해도 로그인 화면으로 보낸다).
            try {
                await axios.post('/logout'); // baseURL 은 _axios 가 붙인다
            } finally {
                for (const key in state.contractor) {
                    localStorage.removeItem(key);
                }
                // 토큰 키 통일: state.contractor 에 없는 카멜 'accessToken' 과 'type' 도 명시 제거.
                // (없으면 로그아웃 후에도 stale accessToken + type=request 가 남아 guard 가
                //  ContractorProgress 로 되돌려보내 로그아웃이 실패한다.)
                localStorage.removeItem('accessToken');
                localStorage.removeItem('accesstoken');
                localStorage.removeItem('type');
                commit('SET_CONTRACTOR_INITIAL');
                commit('SET_PROJECT_LIST', []);
                commit('SET_CONTRACTOR_REQUEST_TIME', null);
                // 루트 계정 식별값(user_id 등)도 비운다 — 같은 창에서 다른 의뢰기업이 로그인할 때(auth_success 없음)
                // 이전 계정 값이 남으면 다른 탭 계정 변경 안전망(isAccountChangedElsewhere)이 정상 요청을 막는다
                commit('logout', null, { root: true });
            }
        }
    }
};
